interface ClassCardStatsProps {
  students: number
  avgScore: number
  engagement: number
}

export function ClassCardStats({ students, avgScore, engagement }: ClassCardStatsProps) {
  return (
    <div className="grid grid-cols-3 gap-4 mb-6">
      <div className="text-center">
        <p className="text-2xl font-bold text-gray-800">{students}</p>
        <p className="text-xs text-gray-500">Students</p>
      </div>
      <div className="text-center border-l border-r border-gray-100">
        <p className="text-2xl font-bold text-[#21a193]">{avgScore}%</p>
        <p className="text-xs text-gray-500">Avg Score</p>
      </div>
      <div className="text-center">
        <p className="text-2xl font-bold text-[#284e8c]">{engagement}%</p>
        <p className="text-xs text-gray-500">Engagement</p>
      </div>
    </div>
  )
}
